document.addEventListener('DOMContentLoaded', function() {
  function initializeValidation() {
    const broderieInputs = document.querySelectorAll('[data-broderie="text"]');
    const submitButton = document.querySelector('button[name="add"]');
    const form = document.querySelector('product-embroidery-form form');

    let globalHasInvalidChars = false;
    let timeout;

    function checkSpecialCharacters() {
      let hasInvalidChars = false;
      broderieInputs.forEach(input => {
        const value = input.value;
        const allowedPattern = /^[a-zA-ZÀ-ÿ0-9\s.,;:!?'"()&@#%€$£*+\/_°-]*$/;
        if (!allowedPattern.test(value) && value !== '') {
          hasInvalidChars = true;
          // Délai avant d'afficher le message sur mobile
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            showError(input);
          }, 300); // 300ms de délai
        } else {
          const errorDiv = input.parentElement.querySelector('.broderie-error');
          if (errorDiv) {
            errorDiv.remove();
          }
        }
      });
      globalHasInvalidChars = hasInvalidChars;
      return hasInvalidChars;
    }

    function showError(input) {
      let errorDiv = input.parentElement.querySelector('.broderie-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'broderie-error text-red-500 text-sm mt-2';
        input.parentElement.appendChild(errorDiv);
      }
      errorDiv.textContent = 'Les caractères spéciaux ne sont pas autorisés.';
    }

    function updateButtonState() {
      if (submitButton) {
        submitButton.disabled = globalHasInvalidChars;
        if (globalHasInvalidChars) {
          submitButton.classList.add('opacity-50', 'cursor-not-allowed');
        } else {
          submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
        }
      }
    }

    // Event listeners
    broderieInputs.forEach(input => {
      input.addEventListener('input', () => {
        checkSpecialCharacters();
        updateButtonState();
      }, { passive: true }); // Optimisation pour mobile
    });

    if (form) {
      form.addEventListener('change', () => {
        updateButtonState();
      }, { passive: true });
    }

    document.addEventListener('click', () => {
      updateButtonState();
    }, { passive: true });

    // Initial check
    checkSpecialCharacters();
    updateButtonState();
  }

  // Observer for dynamic fields
  const observer = new MutationObserver(() => {
    initializeValidation();
  });

  const container = document.querySelector('product-embroidery');
  if (container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  initializeValidation();
});


/* ====================================================================== */
/* BC — Broderie multiple selon la taille "Lot de 2"                      */
/* Affiche le choix "1 / 2 broderies" UNIQUEMENT quand une taille         */
/* contenant "Lot de 2" est sélectionnée. Sur les autres tailles, force   */
/* 1 broderie et masque le choix. N'affecte PAS les produits dont aucune  */
/* taille ne contient "Lot de 2" (ex. serviettes de table).              */
/* ====================================================================== */
(function () {
  function isLot2(v) { return /lot\s*de\s*2/i.test(v || ''); }

  function sizeOf(productId) {
    var radios = document.querySelectorAll('input[name="' + productId + '-taille"], input[name="' + productId + '-size"]');
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i].value; }
    return '';
  }

  function hasLot2Size(productId) {
    var radios = document.querySelectorAll('input[name="' + productId + '-taille"], input[name="' + productId + '-size"]');
    return Array.prototype.some.call(radios, function (r) { return isLot2(r.value); });
  }

  function applyAll() {
    document.querySelectorAll('product-embroidery').forEach(function (emb) {
      var productId = emb.getAttribute('data-product');
      if (!productId) return;
      var fieldset = document.getElementById(emb.id + '--broderie-variant');
      if (!fieldset) return;
      var radios = fieldset.querySelectorAll('input[name="broderie-variant"]');
      var hasMulti = Array.prototype.some.call(radios, function (r) {
        return (parseInt(r.getAttribute('data-max-text-inputs'), 10) || 1) > 1;
      });
      if (!hasMulti) return;               // produit à 1 broderie : ne rien faire
      if (!hasLot2Size(productId)) return; // ex. serviettes de table : laisser le choix 1/2 visible

      var wrapper = fieldset.parentElement;
      var lot2 = isLot2(sizeOf(productId));
      if (wrapper) wrapper.style.display = lot2 ? '' : 'none';

      var input1 = emb.querySelector('input[name="broderie-text-1"]');
      if (input1) input1.placeholder = lot2 ? 'E.L.' : 'Votre texte à broder ici';
      emb.querySelectorAll('.product-embroidery__image-text-input-container legend').forEach(function (l) {
        l.style.display = lot2 ? '' : 'none';
      });

      if (!lot2) {
        var single = fieldset.querySelector('input[name="broderie-variant"][data-max-text-inputs="1"]');
        if (single && !single.checked) {
          single.checked = true;
          single.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; applyAll(); }, 60);
  }

  function init() {
    applyAll();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && /-(taille|size)$/.test(t.name)) { schedule(); }
    });
    var mo = new MutationObserver(function () { schedule(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();